import { css } from 'linaria';
import { StylesMap } from 'types/utils';

export const benefitsCardGrid = css`
  display: grid;
  padding: 0;
  margin: 0;
  column-gap: 24px;
  list-style: none;

  @media (--to-desktop) {
    row-gap: 24px;
  }

  @media (--only-mobile) {
    column-gap: 12px;
    row-gap: 12px;
  }
`;

export const benefitsCardGridMap: StylesMap<number> = {
  4: css`
    grid-template-columns: repeat(4, 1fr);

    @media (--to-desktop) {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 1fr);
    }
  `,
  5: css`
    grid-template-columns: repeat(5, 1fr);

    @media (--only-tablet) {
      grid-template-columns: repeat(6, 1fr);
      grid-template-rows: repeat(2, 1fr);
      row-gap: 24px;

      :nth-child(1),
      :nth-child(2) {
        grid-column: auto / span 3;
      }

      :nth-child(3),
      :nth-child(4),
      :nth-child(5) {
        grid-column: auto / span 2;
      }
    }

    @media (--only-mobile) {
      grid-template-columns: repeat(2, 1fr);
      :nth-child(1) {
        grid-column: auto / span 2;
      }
    }
  `,
};

export const benefitsCardItem = css`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 24px 20px;
  font-family: inherit;
  text-align: left;
  background-color: var(--background-secondary);
  border: none;
  border-radius: var(--rounding-m);
  cursor: pointer;
  row-gap: 32px;

  &:hover {
    background-color: var(--control-minor);
  }

  @media (--only-mobile) {
    padding: 16px 12px;
  }
`;

export const benefitsCardItemImage = css`
  width: 36px;
  height: 36px;

  @media (--only-mobile) {
    position: absolute;
    top: 16px;
    left: 12px;
  }
`;

export const benefitsCardItemContent = css`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (--only-mobile) {
    flex-direction: column-reverse;
    row-gap: 8px;
    align-items: flex-end;
  }
`;

export const benefitsCardItemText = css`
  white-space: break-spaces;

  @media (--only-mobile) {
    width: 100%;
  }
`;

export const benefitsCardItemIconWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: max-content;
  padding: 5px;

  @media (--only-mobile) {
    padding: 8px 4px;
  }
`;

export const benefitsCardItemIcon = css`
  && {
    @media (--only-mobile) {
      width: 24px;
      height: 24px;
    }
  }
`;

export const benefitsCardModal = css`
  && {
    @media (--only-tablet) {
      max-width: 480px;
    }
  }
`;
